
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/second-cond-explanation';
const mainimage = '/Images/secondcond1.webp';

const sections = [
  { label: "Exercises", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "secondcond" },
];

const SecondConditional = () => (
  <GrammarPageLayout
    level="B1"
    title="Second Conditional"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Second Conditional Exercises"
    seoDescription="Practice hypothetical situations: if + past, would + infinitive. B2 level conditional exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default SecondConditional;

